import { render, staticRenderFns } from "./AverageMassInput.vue?vue&type=template&id=5594c1c7&scoped=true"
import script from "./AverageMassInput.vue?vue&type=script&lang=ts"
export * from "./AverageMassInput.vue?vue&type=script&lang=ts"
import style0 from "./AverageMassInput.vue?vue&type=style&index=0&id=5594c1c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5594c1c7",
  null
  
)

export default component.exports